import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { CenteredContainer, Title, Text, Button } from '@nerdwallet/currency';

import Hero from '../employee-branding/hero/hero';
import BoxTable from '~/client/components/employee-branding/box-table/box-table';
import Spacer from '../spacer/spacer';
import BoxTableNarrowData from '../../lib/company-content-src/press-kit-content';

const PressKit = () => (
  <div className="press-archive-page">
    <div
      className={classNames([
        classes('margin-bottom-4'),
        classes('margin-bottom-5--wide'),
      ])}
    >
      <Hero
        backgroundColor="#FFF7EA"
        title="Press kit"
        copy="Looking for pictures or videos to share NerdWallet with the world? We’ve got what you’re looking for."
        imageUrlMobile="https://www.nerdwallet.com/cdn/company/2021/hero/Press-Hero-Mobile.jpg"
        imageUrlDesktop="https://www.nerdwallet.com/cdn/company/2021/hero/Press-Hero-Desktop.jpg"
      />
    </div>
    <CenteredContainer>
      <Title
        size="small"
        className={classNames([
          classes('margin-horizontal-auto'),
          classes('margin-bottom-3'),
          classes('margin-bottom-4--wide'),
          classes('text-align-center'),
        ])}
        component="h2"
      >
        Our brand resources
      </Title>
      <div
        className={classNames([
          classes('margin-horizontal-auto'),
          classes('margin-bottom-3'),
          classes('margin-bottom-4--wide'),
          classes('text-align-center'),
          classes('width-two-thirds--wide'),
        ])}
      >
        <Text>
          From photography and video assets, to logos, we got you. Download our
          entire press kit, or specific assets here.
        </Text>
      </div>
      <div
        className={classNames([
          classes('text-align-center'),
          classes('margin-horizontal-auto'),
          classes('margin-bottom-5'),
        ])}
      >
        <Button
          primary
          href="https://www.nerdwallet.com/cdn/company/2021/kit/downloads/Downloads.zip"
        >
          download all
        </Button>
      </div>
      <BoxTable {...BoxTableNarrowData} />
      <Spacer ndsMarginClass="5" />
    </CenteredContainer>
  </div>
);

PressKit.displayName = 'PressKit';

export default PressKit;
